var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-view-heading d-none d-md-flex"},[_c('span',{staticClass:"static-view-heading__icon"},[_c('AppIcon',{attrs:{"name":_vm.icon}})],1),_c('p',[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }